var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.open
    ? _c(
        "aside",
        {
          staticClass: "wkb-expand-popup",
          style: _vm.aiAssistantOpen
            ? { right: "calc(12px + min(380px, calc(100% - 24px)) + 8px)" }
            : {},
          attrs: {
            role: "dialog",
            "aria-modal": "false",
            "aria-labelledby": "wkb-expand-title",
          },
          on: {
            click: function ($event) {
              $event.stopPropagation()
            },
            mousedown: function ($event) {
              $event.stopPropagation()
            },
          },
        },
        [
          _c("header", { staticClass: "wkb-expand-head" }, [
            _c("div", { staticClass: "wkb-expand-head-row" }, [
              _c("h2", { attrs: { id: "wkb-expand-title" } }, [
                _vm._v("Expand graph"),
              ]),
              _c(
                "button",
                {
                  staticClass: "wkb-expand-close",
                  attrs: {
                    type: "button",
                    "aria-label": "Close",
                    disabled:
                      _vm.loading || _vm.manualAddBusy || _vm.assistantBusy,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("close")
                    },
                  },
                },
                [_vm._v(" × ")]
              ),
            ]),
            _c(
              "p",
              { staticClass: "wkb-expand-intro" },
              [
                _vm.expandFromSingleNode
                  ? [
                      _vm._v(
                        " Fetch neighbors connected to this node. Use Discover to rank candidates, or Add nodes to place a specific node on the graph. "
                      ),
                    ]
                  : _vm.expandFromEdge
                  ? [
                      _vm._v(
                        " Fetch neighbors connected to both endpoints of this edge. Use Discover to rank candidates, or Add nodes to place a specific node on the graph. "
                      ),
                    ]
                  : [
                      _vm._v(
                        " Fetch neighbors from your selected nodes. Use Discover to rank candidates, or Add nodes to place a specific node on the graph. "
                      ),
                    ],
              ],
              2
            ),
            _vm.expandSeedSummary
              ? _c("p", { staticClass: "wkb-expand-anchors" }, [
                  _c("strong", [_vm._v(_vm._s(_vm.expandSeedLabel) + ":")]),
                  _vm._v(" " + _vm._s(_vm.expandSeedSummary) + " "),
                ])
              : _vm._e(),
          ]),
          _c("div", { staticClass: "wkb-expand-tabrow" }, [
            _c(
              "div",
              {
                staticClass: "wkb-expand-tabs",
                attrs: { role: "tablist", "aria-label": "Expand graph modes" },
              },
              [
                _c(
                  "button",
                  {
                    staticClass: "wkb-expand-tab",
                    class: { "is-active": _vm.activeTab === "discover" },
                    attrs: {
                      id: _vm.tabButtonId("discover"),
                      type: "button",
                      role: "tab",
                      "aria-selected":
                        _vm.activeTab === "discover" ? "true" : "false",
                      "aria-controls": _vm.tabPanelId("discover"),
                      disabled: _vm.loading || _vm.manualAddBusy,
                    },
                    on: {
                      click: function ($event) {
                        _vm.activeTab = "discover"
                      },
                    },
                  },
                  [_vm._v(" Discover ")]
                ),
                _c(
                  "button",
                  {
                    staticClass: "wkb-expand-tab",
                    class: { "is-active": _vm.activeTab === "manual" },
                    attrs: {
                      id: _vm.tabButtonId("manual"),
                      type: "button",
                      role: "tab",
                      "aria-selected":
                        _vm.activeTab === "manual" ? "true" : "false",
                      "aria-controls": _vm.tabPanelId("manual"),
                      disabled: _vm.loading || _vm.manualAddBusy,
                    },
                    on: {
                      click: function ($event) {
                        _vm.activeTab = "manual"
                      },
                    },
                  },
                  [_vm._v(" Add nodes ")]
                ),
                _c(
                  "button",
                  {
                    staticClass: "wkb-expand-tab",
                    class: { "is-active": _vm.activeTab === "history" },
                    attrs: {
                      id: _vm.tabButtonId("history"),
                      type: "button",
                      role: "tab",
                      "aria-selected":
                        _vm.activeTab === "history" ? "true" : "false",
                      "aria-controls": _vm.tabPanelId("history"),
                      disabled: _vm.loading || _vm.manualAddBusy,
                    },
                    on: {
                      click: function ($event) {
                        _vm.activeTab = "history"
                      },
                    },
                  },
                  [
                    _vm._v(" History "),
                    _vm.expansionHistoryCount > 0
                      ? _c("span", { staticClass: "wkb-expand-tab-count" }, [
                          _vm._v(_vm._s(_vm.expansionHistoryCount)),
                        ])
                      : _vm._e(),
                  ]
                ),
              ]
            ),
          ]),
          _c("div", { staticClass: "wkb-expand-body" }, [
            _c(
              "section",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.activeTab === "discover",
                    expression: "activeTab === 'discover'",
                  },
                ],
                staticClass: "wkb-expand-tab-panel",
                attrs: {
                  id: _vm.tabPanelId("discover"),
                  role: "tabpanel",
                  "aria-labelledby": _vm.tabButtonId("discover"),
                },
              },
              [
                !_vm.llmAvailable && _vm.expandNeedsLlm
                  ? _c(
                      "p",
                      {
                        staticClass: "wkb-expand-llm-note",
                        attrs: { role: "note" },
                      },
                      [
                        _vm._v(
                          " LLM expansion filters are not available — the interactive API did not report an LLM backend. "
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm.expandTraitGeneSetMode && _vm.intentHasText
                  ? _c(
                      "p",
                      {
                        staticClass: "wkb-expand-trait-gene-set-note",
                        attrs: { role: "note" },
                      },
                      [
                        _vm._v(
                          " Expanding traits to gene sets uses phenotype semantic search (up to " +
                            _vm._s(_vm.traitGeneSetPairSearchMax) +
                            " ranked trait–gene set pairs per trait). Count controls how many gene sets to add from the top pairs (max 20). Matching trait nodes from those pairs are also added. Novelty and expression filters do not apply on this path. "
                        ),
                      ]
                    )
                  : _vm.expandTraitGeneSetMode
                  ? _c(
                      "p",
                      {
                        staticClass: "wkb-expand-trait-gene-set-note",
                        attrs: { role: "note" },
                      },
                      [
                        _vm._v(
                          " Without intent, gene sets are ranked by the same trait connection scores shown in the trait inspector. Count controls how many top gene sets to add (max 20). Add intent below to switch to phenotype semantic search instead. "
                        ),
                      ]
                    )
                  : _vm._e(),
                _c("label", { staticClass: "wkb-expand-field" }, [
                  _c("span", { staticClass: "wkb-expand-label" }, [
                    _vm._v("Target node type"),
                  ]),
                  _c(
                    "select",
                    {
                      staticClass: "wkb-expand-select",
                      attrs: { disabled: _vm.loading },
                      domProps: { value: _vm.controls.targetType || "all" },
                      on: { change: _vm.onTargetTypeChange },
                    },
                    _vm._l(_vm.targetTypeOptions, function (option) {
                      return _c(
                        "option",
                        {
                          key: option.value,
                          attrs: {
                            disabled: _vm.isTargetTypeDisabled(option.value),
                          },
                          domProps: { value: option.value },
                        },
                        [_vm._v(" " + _vm._s(option.label) + " ")]
                      )
                    }),
                    0
                  ),
                ]),
                _c("div", { staticClass: "wkb-expand-controls-row" }, [
                  _c("label", { staticClass: "wkb-expand-field" }, [
                    _c("span", { staticClass: "wkb-expand-label" }, [
                      _vm._v("Match to selected nodes"),
                    ]),
                    _c(
                      "select",
                      {
                        staticClass: "wkb-expand-select",
                        attrs: {
                          disabled: _vm.loading || _vm.expandFromSingleNode,
                        },
                        domProps: { value: _vm.controls.reducer || "mean" },
                        on: { change: _vm.onReducerChange },
                      },
                      _vm._l(_vm.matchRequirementOptions, function (option) {
                        return _c(
                          "option",
                          {
                            key: option.value,
                            domProps: { value: option.value },
                          },
                          [_vm._v(" " + _vm._s(option.label) + " ")]
                        )
                      }),
                      0
                    ),
                    _vm.expandFromSingleNode
                      ? _c("small", { staticClass: "wkb-expand-hint" }, [
                          _vm._v(
                            " Not applicable when expanding from a single node. "
                          ),
                        ])
                      : _c("small", { staticClass: "wkb-expand-hint" }, [
                          _vm._v(_vm._s(_vm.matchReducerHelp)),
                        ]),
                  ]),
                  _c(
                    "label",
                    {
                      staticClass: "wkb-expand-field wkb-expand-field--narrow",
                    },
                    [
                      _c("span", { staticClass: "wkb-expand-label" }, [
                        _vm._v("Count"),
                      ]),
                      _c("input", {
                        staticClass: "wkb-expand-input",
                        attrs: {
                          type: "number",
                          min: "1",
                          max: _vm.expandMaxNeighbors,
                          disabled: _vm.loading,
                        },
                        domProps: { value: _vm.controls.limit },
                        on: { change: _vm.onLimitChange },
                      }),
                      _c(
                        "small",
                        { staticClass: "wkb-expand-hint" },
                        [
                          _vm.expandTraitGeneSetMode && _vm.intentHasText
                            ? [
                                _vm._v(
                                  " Max gene sets to add (semantic search ranks up to " +
                                    _vm._s(_vm.traitGeneSetPairSearchMax) +
                                    " pairs per trait; traits from those pairs are added too). "
                                ),
                              ]
                            : _vm.expandTraitGeneSetMode
                            ? [
                                _vm._v(
                                  " Max gene sets to add from trait connection scores (trait inspector table). "
                                ),
                              ]
                            : [
                                _vm._v(
                                  " Max neighbors to add. AI classification often stops early once this many pass your filters. "
                                ),
                              ],
                        ],
                        2
                      ),
                      _vm.showBulkWorkflowHint
                        ? _c(
                            "p",
                            {
                              staticClass: "wkb-expand-workflow-hint",
                              attrs: { role: "status" },
                            },
                            [
                              _vm._v(
                                " Need more than " +
                                  _vm._s(_vm.expandMaxNeighbors) +
                                  " neighbors at once? "
                              ),
                              _c(
                                "a",
                                {
                                  staticClass: "wkb-expand-workflow-link",
                                  attrs: {
                                    href: _vm.workflowUrl,
                                    target: "_blank",
                                    rel: "noopener noreferrer",
                                  },
                                },
                                [_vm._v("Open " + _vm._s(_vm.workflowTitle))]
                              ),
                              _vm._v(
                                " for bulk discovery of genes, gene sets, and traits from your research intention. "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]
                  ),
                ]),
                _c("label", { staticClass: "wkb-expand-hop-option" }, [
                  _c("input", {
                    attrs: { type: "checkbox", disabled: _vm.loading },
                    domProps: {
                      checked: _vm.controls.connectionScope === "expanded",
                    },
                    on: { change: _vm.onTwoHopToggle },
                  }),
                  _c("span", [_vm._v("Allow two-hop")]),
                ]),
                _c("hr", {
                  staticClass: "wkb-expand-divider",
                  attrs: { "aria-hidden": "true" },
                }),
                _c("label", { staticClass: "wkb-expand-type-field" }, [
                  _c("span", { staticClass: "wkb-expand-label" }, [
                    _vm._v("Expand with"),
                  ]),
                  _c(
                    "select",
                    {
                      staticClass: "wkb-expand-type-select",
                      attrs: {
                        id: `${_vm.panelId}-expand-filter-type`,
                        disabled: _vm.loading,
                      },
                      domProps: { value: _vm.expandFilterType },
                      on: { change: _vm.onExpandFilterTypeChange },
                    },
                    _vm._l(_vm.expandFilterTypeOptions, function (option) {
                      return _c(
                        "option",
                        {
                          key: option.value,
                          domProps: { value: option.value },
                        },
                        [_vm._v(" " + _vm._s(option.label) + " ")]
                      )
                    }),
                    0
                  ),
                ]),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.expandFilterType === "intent",
                        expression: "expandFilterType === 'intent'",
                      },
                    ],
                    staticClass: "wkb-expand-option wkb-expand-intent",
                  },
                  [
                    _vm._m(0),
                    _c("small", { staticClass: "wkb-expand-hint" }, [
                      _vm._v(
                        " Optional focus for relevance when ranking new connections. "
                      ),
                    ]),
                    _c("textarea", {
                      staticClass: "wkb-expand-textarea",
                      attrs: {
                        id: "wkb-expand-intent",
                        rows: "2",
                        disabled: _vm.loading,
                        placeholder:
                          "e.g. mechanisms linked to insulin resistance",
                      },
                      domProps: { value: _vm.filters.intent || "" },
                      on: { input: _vm.onIntentInput },
                    }),
                    _vm._v(" "),
                    _c(
                      "label",
                      { staticClass: "wkb-expand-intent-suboption" },
                      [
                        _c("input", {
                          attrs: {
                            type: "checkbox",
                            disabled: _vm.loading || !_vm.intentHasText,
                          },
                          domProps: {
                            checked: _vm.filters.relevanceMode === "semantic",
                          },
                          on: { change: _vm.onSemanticToggle },
                        }),
                        _c("span", [_vm._v("Rank with semantic similarity")]),
                      ]
                    ),
                    _vm.intentHasText &&
                    _vm.filters.relevanceMode === "semantic"
                      ? _c(
                          "p",
                          {
                            staticClass:
                              "wkb-expand-hint wkb-expand-intent-helper",
                          },
                          [
                            _vm._v(
                              " Prefer neighbors whose descriptions match your intent (embedding-based), combined with session context, instead of LLM relevance labels. "
                            ),
                          ]
                        )
                      : _vm.intentHasText
                      ? _c(
                          "p",
                          {
                            staticClass:
                              "wkb-expand-hint wkb-expand-intent-helper",
                          },
                          [
                            _vm._v(
                              " Neighbors are ranked by LLM relevance to your intent and session context. "
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]
                ),
                _c(
                  "fieldset",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.expandFilterType === "novelty",
                        expression: "expandFilterType === 'novelty'",
                      },
                    ],
                    staticClass: "wkb-expand-option wkb-expand-novelty",
                    attrs: { disabled: _vm.loading },
                  },
                  [
                    _vm._m(1),
                    _c("p", { staticClass: "wkb-expand-novelty-intro" }, [
                      _vm._v(
                        " Only add nodes classified as known or novel when expanding. "
                      ),
                    ]),
                    _c("div", { staticClass: "wkb-expand-novelty-options" }, [
                      _c(
                        "label",
                        { staticClass: "wkb-expand-novelty-option" },
                        [
                          _c("input", {
                            attrs: { type: "checkbox" },
                            domProps: {
                              checked: Boolean(_vm.filters.noveltyKnown),
                            },
                            on: {
                              change: function ($event) {
                                return _vm.$emit("toggle-novelty", "known")
                              },
                            },
                          }),
                          _c("span", [_vm._v("Known")]),
                        ]
                      ),
                      _c(
                        "label",
                        { staticClass: "wkb-expand-novelty-option" },
                        [
                          _c("input", {
                            attrs: { type: "checkbox" },
                            domProps: {
                              checked: Boolean(_vm.filters.noveltyNovel),
                            },
                            on: {
                              change: function ($event) {
                                return _vm.$emit("toggle-novelty", "novel")
                              },
                            },
                          }),
                          _c("span", [_vm._v("Novel")]),
                        ]
                      ),
                    ]),
                  ]
                ),
                _c(
                  "section",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.expandFilterType === "expression",
                        expression: "expandFilterType === 'expression'",
                      },
                    ],
                    staticClass: "wkb-expand-option wkb-expand-expression",
                  },
                  [
                    _c("h4", { staticClass: "wkb-expand-subsection-title" }, [
                      _vm._v("Gene expression filter"),
                    ]),
                    _c("WorkspaceExpressionFilterControls", {
                      attrs: {
                        filters: _vm.filters,
                        options: _vm.expressionOptions,
                        compact: "",
                        "use-select-dropdowns": "",
                      },
                      on: {
                        change: function ($event) {
                          return _vm.$emit("patch-filters", $event)
                        },
                      },
                    }),
                  ],
                  1
                ),
              ]
            ),
            _c(
              "section",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.activeTab === "manual",
                    expression: "activeTab === 'manual'",
                  },
                ],
                staticClass: "wkb-expand-tab-panel wkb-expand-add-nodes",
                attrs: {
                  id: _vm.tabPanelId("manual"),
                  role: "tabpanel",
                  "aria-labelledby": _vm.tabButtonId("manual"),
                },
              },
              [
                _c("div", { staticClass: "wkb-add-nodes-accordions" }, [
                  _c(
                    "div",
                    {
                      staticClass: "wkb-add-nodes-accordion",
                      class: { "is-open": _vm.addNodesAccordion === "intent" },
                    },
                    [
                      _c(
                        "button",
                        {
                          staticClass: "wkb-add-nodes-accordion-trigger",
                          attrs: {
                            type: "button",
                            "aria-expanded":
                              _vm.addNodesAccordion === "intent"
                                ? "true"
                                : "false",
                            "aria-controls":
                              _vm.addNodesAccordionPanelId("intent"),
                            disabled: _vm.loading || _vm.manualAddBusy,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.toggleAddNodesAccordion("intent")
                            },
                          },
                        },
                        [
                          _c("span", [
                            _vm._v("Add nodes with research intention"),
                          ]),
                          _c("span", {
                            staticClass: "wkb-add-nodes-accordion-chevron",
                            attrs: { "aria-hidden": "true" },
                          }),
                        ]
                      ),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.addNodesAccordion === "intent",
                              expression: "addNodesAccordion === 'intent'",
                            },
                          ],
                          staticClass: "wkb-add-nodes-accordion-panel",
                          attrs: {
                            id: _vm.addNodesAccordionPanelId("intent"),
                            role: "region",
                            "aria-label": "Add nodes with research intention",
                          },
                        },
                        [
                          _c("WorkspaceExpandIntentAdd", {
                            attrs: {
                              "llm-available": _vm.llmAvailable,
                              busy: _vm.intentAddBusy || _vm.manualAddBusy,
                              "status-message": _vm.intentAddStatus,
                              "last-explanation": _vm.intentAddExplanation,
                            },
                            on: {
                              run: function ($event) {
                                return _vm.$emit("intent-add-nodes", $event)
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "wkb-add-nodes-accordion",
                      class: { "is-open": _vm.addNodesAccordion === "search" },
                    },
                    [
                      _c(
                        "button",
                        {
                          staticClass: "wkb-add-nodes-accordion-trigger",
                          attrs: {
                            type: "button",
                            "aria-expanded":
                              _vm.addNodesAccordion === "search"
                                ? "true"
                                : "false",
                            "aria-controls":
                              _vm.addNodesAccordionPanelId("search"),
                            disabled: _vm.loading || _vm.manualAddBusy,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.toggleAddNodesAccordion("search")
                            },
                          },
                        },
                        [
                          _c("span", [_vm._v("Add nodes with search")]),
                          _c("span", {
                            staticClass: "wkb-add-nodes-accordion-chevron",
                            attrs: { "aria-hidden": "true" },
                          }),
                        ]
                      ),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.addNodesAccordion === "search",
                              expression: "addNodesAccordion === 'search'",
                            },
                          ],
                          staticClass: "wkb-add-nodes-accordion-panel",
                          attrs: {
                            id: _vm.addNodesAccordionPanelId("search"),
                            role: "region",
                            "aria-label": "Add nodes with search",
                          },
                        },
                        [
                          _c("WorkspaceExpandManualAdd", {
                            attrs: {
                              "api-client": _vm.apiClient,
                              "llm-available": _vm.llmAvailable,
                              "gene-set-semantic-search-available":
                                _vm.geneSetSemanticSearchAvailable,
                              "existing-node-ids": _vm.graphNodeIds,
                              busy: _vm.manualAddBusy,
                            },
                            on: {
                              add: function ($event) {
                                return _vm.$emit("add-manual-node", $event)
                              },
                              error: function ($event) {
                                return _vm.$emit("manual-add-error", $event)
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                ]),
              ]
            ),
            _c(
              "section",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.activeTab === "history",
                    expression: "activeTab === 'history'",
                  },
                ],
                staticClass: "wkb-expand-tab-panel",
                attrs: {
                  id: _vm.tabPanelId("history"),
                  role: "tabpanel",
                  "aria-labelledby": _vm.tabButtonId("history"),
                },
              },
              [
                _c("WorkspaceExpandHistoryPanel", {
                  attrs: {
                    entries: _vm.expansionHistoryEntries,
                    loading: _vm.loading,
                  },
                  on: {
                    "remove-entry": function ($event) {
                      return _vm.$emit("remove-history-entry", $event)
                    },
                  },
                }),
              ],
              1
            ),
          ]),
          _vm.activeTab === "discover"
            ? _c("div", { staticClass: "wkb-expand-actions" }, [
                _c(
                  "button",
                  {
                    staticClass: "wkb-expand-btn wkb-expand-btn-primary",
                    attrs: {
                      type: "button",
                      disabled:
                        _vm.loading ||
                        (!_vm.llmAvailable && _vm.expandNeedsLlm),
                    },
                    on: {
                      click: function ($event) {
                        return _vm.$emit("expand")
                      },
                    },
                  },
                  [_vm._v(" Expand graph ")]
                ),
              ])
            : _vm._e(),
          _vm.assistantBusy
            ? _c(
                "div",
                {
                  staticClass: "wkb-expand-assistant-overlay",
                  attrs: {
                    role: "alertdialog",
                    "aria-modal": "true",
                    "aria-live": "assertive",
                    "aria-busy": "true",
                    "aria-label":
                      _vm.assistantMessage || "AI Assist is running",
                  },
                },
                [
                  _c(
                    "div",
                    { staticClass: "wkb-expand-assistant-overlay-card" },
                    [
                      _c("span", {
                        staticClass: "wkb-expand-assistant-spinner",
                        attrs: { "aria-hidden": "true" },
                      }),
                      _c("p", { staticClass: "wkb-expand-assistant-title" }, [
                        _vm._v("AI Assist is running"),
                      ]),
                      _c("p", { staticClass: "wkb-expand-assistant-message" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.assistantMessage ||
                                "Running an expansion for you…"
                            ) +
                            " "
                        ),
                      ]),
                      _c("p", { staticClass: "wkb-expand-assistant-note" }, [
                        _vm._v(
                          " You do not need to change anything in this panel — Assist will continue automatically. "
                        ),
                      ]),
                    ]
                  ),
                ]
              )
            : _vm._e(),
        ]
      )
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "wkb-expand-option-head" }, [
      _c(
        "label",
        {
          staticClass: "wkb-expand-label",
          attrs: { for: "wkb-expand-intent" },
        },
        [_vm._v("Intent")]
      ),
      _c(
        "span",
        {
          staticClass: "wkb-expand-ai-badge",
          attrs: { title: "Uses LLM or semantic classification" },
        },
        [_vm._v("AI")]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "wkb-expand-option-head" }, [
      _c("legend", { staticClass: "wkb-expand-novelty-legend" }, [
        _vm._v("Known / Novel"),
      ]),
      _c(
        "span",
        {
          staticClass: "wkb-expand-ai-badge",
          attrs: { title: "Uses LLM classification" },
        },
        [_vm._v("AI")]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }